import type { LandingPageContent } from './types'

export const PHOTOVOLTAIK_FOERDERUNG: LandingPageContent = {
  slug: 'photovoltaik-foerderung',
  lang: 'de',
  topicId: 'photovoltaik-foerderung',
  title: 'Photovoltaik-Förderung: KfW, Einspeisevergütung & Zuschüsse im Überblick',
  metaDescription:
    'Förderung auf Bundes-, Landes- und kommunaler Ebene im Überblick - und wie Sie trotzdem fair ' +
    'vergleichen. Stand: August 2026, jährlich zu prüfen.',
  keywords: [
    'photovoltaik förderung',
    'kfw photovoltaik',
    'einspeisevergütung',
    'pv förderung bundesland',
    'photovoltaik steuer',
    'batteriespeicher förderung',
  ],
  eyebrow: 'Förderung · Stand: August 2026',
  h1: 'Photovoltaik-Förderung: Was Sie 2026 wissen sollten',
  intro:
    'Förderungen verändern den tatsächlichen Endpreis einer Solaranlage oft stärker als jede ' +
    'Preisverhandlung. Diese Seite fasst die wichtigsten Eckpunkte auf Bundesebene zusammen und ' +
    'erklärt, warum Förderung am fairen Angebotsvergleich nichts ändert.',
  sections: [
    { type: 'heading', text: 'Bundesebene: die wichtigsten Eckpunkte' },
    {
      type: 'list',
      items: [
        '0% Mehrwertsteuer auf Kauf und Installation kleinerer Photovoltaikanlagen - gilt unverändert und unbefristet',
        'Einnahmen aus privaten PV-Anlagen bis 30 kWp sind einkommensteuerbefreit - keine Gewerbeanmeldung nötig',
        'EEG-Einspeisevergütung: fester Satz pro kWh für 20 Jahre ab Inbetriebnahme, Höhe sinkt regelmäßig für neu in Betrieb genommene Anlagen - wer früher startet, sichert sich tendenziell den höheren Satz',
        'KfW-Kredit 270: zinsgünstige Finanzierung, Konditionen ändern sich laufend',
      ],
    },
    { type: 'heading', text: 'Wichtige Änderung ab 2027: EEG-Reform angekündigt' },
    {
      type: 'paragraph',
      text:
        'Das Bundeswirtschaftsministerium hat in einem Referentenentwurf angekündigt, die feste ' +
        'Einspeisevergütung für neue Anlagen bis 25 kWp ab 2027 einzustellen - Betreiber sollen ' +
        'ihren Überschussstrom stattdessen direkt an der Strombörse vermarkten. Das ist Stand August ' +
        '2026 ein Entwurf, kein final beschlossenes Gesetz - wer noch 2026 eine Anlage in Betrieb ' +
        'nimmt, sichert sich die zum Zeitpunkt der Inbetriebnahme gültige Festvergütung für die ' +
        'gesamten 20 Jahre, unabhängig von der Reform.',
    },
    { type: 'heading', text: 'Länder und Kommunen: regional sehr unterschiedlich' },
    {
      type: 'paragraph',
      text:
        'Nur noch ein Teil der Bundesländer hat aktuell eigene Förderprogramme - mehrere frühere ' +
        'Landesprogramme wurden ohne Nachfolger eingestellt. Kommunale Zuschüsse (teils bis zu ' +
        'niedrigem fünfstelligem Bereich, je nach Gemeinde völlig unterschiedlich) sind deshalb oft ' +
        'die relevantere Ebene. Eine aktuelle, nach Bundesland und Zielgruppe filterbare Übersicht ' +
        'bietet die öffentliche Förderdatenbank des Bundes (foerderdatenbank.de) - dort finden Sie ' +
        'die für Ihren Wohnort tatsächlich gültigen Programme, aktueller als jede statische Liste es ' +
        'sein kann.',
    },
    { type: 'heading', text: 'Was das für Ihren Angebotsvergleich bedeutet' },
    {
      type: 'paragraph',
      text:
        'Förderungen ändern nichts an der Grundlogik des Vergleichs: der faire Maßstab bleibt der ' +
        'Preis vor Förderung, weil Förderungen unabhängig vom gewählten Handwerksbetrieb greifen. Bei ' +
        'Roofora vergleichen Sie zunächst unverbindliche Festpreis-Angebote mehrerer Betriebe - erst ' +
        'danach lohnt sich der Blick auf die für Sie zutreffenden Förderprogramme.',
    },
  ],
  faq: [
    {
      q: 'Muss ich die Förderung vor oder nach der Angebotseinholung beantragen?',
      a: 'Der Förderantrag muss bei praktisch allen Landes- und Kommunalprogrammen gestellt werden, bevor die Anlage gekauft oder montiert wird - planen Sie das ein, sobald erste Angebote vorliegen, nicht erst nach der Auftragsvergabe.',
    },
    {
      q: 'Warum nennt diese Seite keine Bundesland-Fördersätze im Detail?',
      a: 'Weil sich Landes- und Kommunalprogramme laufend ändern und wir dafür keine belastbar aktuelle eigene Datengrundlage pflegen können - die offizielle Förderdatenbank des Bundes (foerderdatenbank.de) ist dafür die verlässlichere, tagesaktuelle Quelle.',
    },
    {
      q: 'Ändert sich meine Einspeisevergütung nachträglich, wenn sich die Gesetzeslage ändert?',
      a: 'Nein - die zum Zeitpunkt der Inbetriebnahme geltende Vergütung gilt für 20 Jahre fest, unabhängig von späteren Gesetzesänderungen für neue Anlagen.',
    },
  ],
  primaryCta: { label: 'Jetzt kostenlos Angebote vergleichen', action: 'customer' },
  secondaryCta: { label: 'Ausführlicher Förder-Ratgeber (DE & Österreich)', action: 'link', href: '/blog/photovoltaik-foerderung-2026' },
  relatedLinks: [
    { label: 'Was kostet eine Solaranlage?', href: '/solaranlage-kosten' },
    { label: 'So funktioniert der Angebotsvergleich', href: '/pv-angebot-vergleichen' },
    { label: 'Photovoltaik-Förderung 2026: Ausführlicher Ratgeber', href: '/blog/photovoltaik-foerderung-2026' },
  ],
}
